module.exports = __webpack_public_path__ + "static/media/21ECLAC14.4d8b8211.jpg";